import { render, staticRenderFns } from "./menuLangApp.vue?vue&type=template&id=2d24f18e&scoped=true"
import script from "./menuLangApp.vue?vue&type=script&lang=js"
export * from "./menuLangApp.vue?vue&type=script&lang=js"
import style0 from "./menuLangApp.vue?vue&type=style&index=0&id=2d24f18e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24f18e",
  null
  
)

export default component.exports